import { render, staticRenderFns } from "./CatalogBannersFrom.vue?vue&type=template&id=21e9a2cc&"
import script from "./CatalogBannersFrom.vue?vue&type=script&lang=js&"
export * from "./CatalogBannersFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports